module.exports = __webpack_public_path__ + "static/media/p_5_1.1426ef4d.png";